import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../api";
import YouTubeEmbed from "./YoutubeEmbed";
import Draggable from "./Draggable";
import VariableTextCell from "./VariableTextCell";
import ListItem from "./ListItem";

import ParseStringWithLinks from "../hooks/parseStringWithLinks";
import { styleThresholds } from "../resources/styleThresholds";
import CheckStyleThreshold from "../hooks/checkStyleThreshold";
import Draggables from "./Draggables";

function Project({ info, template, exiting, onExitingDone, isNext }) {
  const {
    title,
    description,
    coauthors,
    links,
    categories,
    technologies,
    video_ids,
    gallery,
  } = info;

  const [isUnderStyleThreshold, setIsUnderStyleThreshold] = useState(null);
  const [prevUnderThreshold, setPrevUnderThreshold] = useState(false);

  const [descriptionParagraphIndexs, setDescriptionParagraphIndexs] = useState(
    []
  );
  const [videoIDList, setVideoIDList] = useState([]);
  const [linksList, setLinksList] = useState([]);

  const [projectDivsDistribution, setProjectDivsDistribution] = useState({});

  const [categoryState, setCategoryState] = useState(null);
  const [descriptionParagraphIndex, setDescriptionParagraphIndex] =
    useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);

  const [mediaIndices, setMediaIndices] = useState(null);

  const [animationClass, setAnimationClass] = useState(null);
  const [nCellsAnimated, setNCellsAnimated] = useState(null);

  useEffect(() => {
    //setAnimationClass(isNext ? "enterPrevious" : "enterNext");
    setNCellsAnimated(0);
    setCategoryState(0);
    setDescriptionParagraphIndex(0);
    setCurrentVideoIndex(0);
    setDescriptionParagraphIndexs(description ? description.split("#") : null);
    setVideoIDList(video_ids ? video_ids.split("#") : null);
    setLinksList(links ? links.split("#") : null);
    setCategoryState(-1);
    handleCategoryClick();
  }, [info]);

  //resize observer
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      doStyleThreshold();
    });

    doStyleThreshold();
    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  //setup template & project divs
  useEffect(() => {
    setNProjectDivs();
  }, [template]);

  useEffect(() => {
    setNCellsAnimated(0);

    if (exiting) {
      if (isNext) setAnimationClass("exitNext");
      else setAnimationClass("exitPrevious");

      setTimeout(endTransition, 1201);
    } else {
      setAnimationClass(isNext ? "enterNext" : "enterPrevious");

      setTimeout(endTransition, 601);
    }
  }, [exiting]);

  const doStyleThreshold = () => {
    const isUnderThreshold = CheckStyleThreshold();
    setIsUnderStyleThreshold(isUnderThreshold);
  };

  useEffect(() => {
    if (isUnderStyleThreshold !== prevUnderThreshold) {
      setPrevUnderThreshold(isUnderStyleThreshold);
      setNProjectDivs();
    }
  }, [isUnderStyleThreshold, prevUnderThreshold]);

  const setNProjectDivs = () => {
    const totalProjectDivs = template.styles.length;

    const nDescriptionDivs = description ? 1 : 0;

    const nCategoriesDivs = categories ? 1 : 0;

    const nVideoDivs = video_ids ? 1 : 0;

    let nMediaDivs = Math.min(
      totalProjectDivs - nDescriptionDivs - nCategoriesDivs - nVideoDivs,
      gallery ? gallery.length : 0
    );

    if (isUnderStyleThreshold) {
      nMediaDivs = video_ids ? 1 : 2;
    }

    if (gallery) {
      let indicesToSet = [];
      for (let i = 0; i < nMediaDivs; i++) {
        indicesToSet.push(i);
      }
      setMediaIndices(indicesToSet);
    }

    setProjectDivsDistribution({
      media: nMediaDivs,
      description: nDescriptionDivs,
      categories: nCategoriesDivs,
      video: nVideoDivs,
      total: nMediaDivs + nVideoDivs + nDescriptionDivs + nCategoriesDivs,
    });
  };

  const projectDivs = () => {
    if (!projectDivsDistribution.total) return;

    const totalArray = Array.from(
      { length: projectDivsDistribution.total },
      (_, i) => i
    );

    return totalArray.map((i) => {
      let style = { gridArea: template.styles[i] };
      if (CheckStyleThreshold()) style = null;

      if (i < projectDivsDistribution.media) {
        //media

        let galleryIndex = i;
        if (galleryIndex > gallery.length) {
          galleryIndex = Math.floor(Math.random(gallery.length));
        }

        return (
          <figure
            onClick={() => handleMediaClick(i)}
            key={"project_container" + i}
            className={`project_media project_container cell button ${animationClass}`}
            style={style}
            onTransitionEnd={handleTransitionEnd}
          >
            <img
              src={gallery[mediaIndices[galleryIndex]].full_image_url}
              alt="Project Image"
              loading="lazy"
            ></img>
            {gallery.length > 1 ? (
              <div className="carousel">
                {gallery.map((j, index) => {
                  return (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMediaCarouselClick(i, index);
                      }}
                      className={`${
                        mediaIndices[galleryIndex] === index ? "selected" : ""
                      }`}
                      key={"image_carousel" + i + index}
                    >
                      <div>
                        <svg
                          width="10"
                          height="10"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect x="0" y="0" width="10" height="10" />
                        </svg>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </figure>
        );
      } else if (
        i <
        projectDivsDistribution.media + projectDivsDistribution.video
      ) {
        //video
        if (!videoIDList)
          return (
            <div
              key={"project_container" + i}
              className={`project_video project_media project_container cell ${animationClass}`}
              style={style}
              onTransitionEnd={handleTransitionEnd}
            ></div>
          );
        return (
          <div
            onClick={() => handleVideoClick()}
            key={"project_container" + i}
            className={`project_video project_container cell ${animationClass} ${
              videoIDList.length > 1 ? "button" : ""
            }`}
            style={style}
            onTransitionEnd={handleTransitionEnd}
          >
            <YouTubeEmbed id={videoIDList[currentVideoIndex]}></YouTubeEmbed>
            {videoIDList.length > 1 ? (
              <div className="carousel">
                {videoIDList.map((j, index) => {
                  return (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleVideoCarouselClick(index);
                      }}
                      className={`${
                        currentVideoIndex === index ? "selected" : ""
                      }`}
                      key={"video_carousel" + i + index}
                    >
                      <div>
                        <svg
                          width="10"
                          height="10"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect x="0" y="0" width="10" height="10" />
                        </svg>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      } else if (
        i <
        projectDivsDistribution.media +
          projectDivsDistribution.description +
          projectDivsDistribution.video
      ) {
        //description
        return (
          <div
            onClick={(e) => handleDescriptionClick(e)}
            key={"project_container" + i}
            className={`project_description project_container cell button text-body ${animationClass}`}
            style={style}
            onTransitionEnd={handleTransitionEnd}
          >
            <div className="project_description_inner">
              <div>
              {ParseStringWithLinks(
                descriptionParagraphIndexs[descriptionParagraphIndex]
              )}
              </div>
            </div>
            {descriptionParagraphIndexs.length > 1 ? (
              <div className="carousel">
                {descriptionParagraphIndexs.map((j, index) => {
                  return (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDescriptionCarouselClick(index);
                      }}
                      className={`${
                        descriptionParagraphIndex === index ? "selected" : ""
                      }`}
                      key={"description_carousel" + i + index}
                    >
                      <div>
                        <svg
                          width="10"
                          height="10"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect x="0" y="0" width="10" height="10" />
                        </svg>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        );
      } else {
        //categories & technologies
        if (!categories && !technologies && !linksList)
          return (
            <div
              key={"project_container" + i}
              className={`project_categories project_container cell  ${animationClass}`}
              style={style}
              onTransitionEnd={handleTransitionEnd}
            ></div>
          );
        return (
          <div
            onClick={() => handleCategoryClick()}
            key={"project_container" + i}
            className={`project_categories project_container cell text-list ${animationClass}`}
            style={style}
            onTransitionEnd={handleTransitionEnd}
          >
            <div className="categories">
              {categories.map((cat, idx) => (
                <ListItem
                  text={cat}
                  className="category_span cell"
                  key={"category" + idx}
                ></ListItem>
              ))}
            </div>
            <div className="technologies">
              {technologies.map((cat, idx) => (
                <ListItem
                  text={cat}
                  className="technology_span cell"
                  key={"technology" + idx}
                >
                </ListItem>
              ))}
            </div>
          </div>
        );
      }
    });
  };

  const handleMediaClick = (divIndex) => {
    setMediaIndices((prevIndices) => {
      let nextIndex = (prevIndices[divIndex] + 1) % gallery.length;

      const newIndices = [...prevIndices];

      if (gallery.length > mediaIndices.length) {
        while (newIndices.includes(nextIndex)) {
          nextIndex = (nextIndex + 1) % gallery.length;
        }
      }

      newIndices[divIndex] = nextIndex;

      return newIndices;
    });
  };

  const handleMediaCarouselClick = (divIndex, carouselIndex) => {
    setMediaIndices((prevIndices) => {
      const newIndices = [...prevIndices];

      newIndices[divIndex] = carouselIndex % gallery.length;

      return newIndices;
    });
  };

  const handleVideoClick = () => {
    let newVideoIndex = (currentVideoIndex + 1) % videoIDList.length;

    setCurrentVideoIndex(newVideoIndex);
  };

  const handleVideoCarouselClick = (carouselIndex) => {
    console.log("video carousel", carouselIndex);
    setCurrentVideoIndex(carouselIndex % videoIDList.length);
  };

  const handleDescriptionClick = (e) => {
    if (e.target.tagName === "A") {
      return;
    }

    let newParagraphIndex =
      (descriptionParagraphIndex + 1) % descriptionParagraphIndexs.length;

    setDescriptionParagraphIndex(newParagraphIndex);
  };

  const handleDescriptionCarouselClick = (carouselIndex) => {
    setDescriptionParagraphIndex(
      carouselIndex % descriptionParagraphIndexs.length
    );
  };

  const handleCategoryClick = () => {
    let newState = (categoryState + 1) % 3;

    if (newState === 0 && !categories?.length) newState = 1;
    if (newState === 1 && !technologies?.length) newState = 2;
    if (newState === 2 && !linksList?.length) newState = 0;

    setCategoryState(newState);
  };

  const handleTransitionEnd = () => {
    return;
    setNCellsAnimated((prev) => {
      const nAnimated = prev + 1;
      if (nAnimated === projectDivsDistribution.total) {
        //if (exiting) {
        //  onExitingDone();
        //} else {
        //  setAnimationClass("");
        //}

        endTransition();

        return 0;
      }

      return nAnimated;
    });
  };

  const endTransition = () => {
    if (exiting) {
      onExitingDone();
    } else {
      setAnimationClass("");
    }

    setNCellsAnimated(0);
  };

  return (
    <>
      {projectDivs()}
      <Draggables draggableStyles={template.draggable_styles}></Draggables>
    </>
  );
}

export default Project;
